import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, PencilSimple, Trash, X } from '@phosphor-icons/react';
import Avatar from '../../Utility/Avatar';
import {
    setMobileMenuOpen,
    setNavigationImage,
    setNavigationSubTitle,
    setNavigationTitle,
} from '../../../Store/Actions/navigationHeaderActions';
import { setChatlistOpenHover } from '../../../Store/Actions/chatlistActions';
import { useDispatch, useSelector } from 'react-redux';
import { ChatMessageRole } from '../../../Types/Enums';

interface ChatListItemProps {
    chatIdentifier: string;
    currentUrl: string;
    deleteChat: (chatId: string) => void;
    chatTitle: string;
    editItem: string;
    setCanEdit: (chatId: string) => void;
    updateChatTitle: (chatId: string, title: string) => void;
    assistantTitle: string;
    assistantImage: string;
}

export default function ChatListItem({
    chatIdentifier,
    currentUrl,
    deleteChat,
    chatTitle,
    editItem = '',
    setCanEdit,
    updateChatTitle,
    assistantTitle = '',
    assistantImage = '',
}: ChatListItemProps) {
    const [initialTitle, setinitialTitle] = useState(chatTitle);
    const [chatTitleInput, setChatTitleInput] = useState(chatTitle);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const chatlistOpen = useSelector((state: any) => state.chatlist.chatlistOpen);

    useEffect(() => {
        setChatTitleInput(chatTitle);
        setinitialTitle(chatTitle);
    }, [chatTitle]);

    const updateTitle = async () => {
        if (chatTitleInput !== initialTitle) {
            setinitialTitle(chatTitleInput);
            updateChatTitle(chatIdentifier, chatTitleInput);
        }
    };

    const handleInputChange = (e: any) => {
        setChatTitleInput(e);
    };

    return (
        <>
            <li
                key={chatIdentifier}
                data-mode={editItem === chatIdentifier ? 'edit' : ''}
                className={`py-1 px-2 justify-between hover:bg-chatlist-item-background-hover list-none h-[45px] group flex w-full m-0 justify-left gap-2 items-center rounded-xl transition duration-100 relative ${
                    currentUrl.includes(chatIdentifier) && 'active bg-chatlist-item-background-hover'
                }`}
            >
                {editItem === chatIdentifier ? (
                    <input
                        className="w-full pl-2 py-[10px] h-[30px] xl:max-w-[160px] rounded-md border-borderColor border bg-chatlist-background focus-visible:outline-none pr-2"
                        type="text"
                        value={chatTitleInput}
                        onChange={(e) => handleInputChange(e.target.value)}
                    />
                ) : (
                    <button
                        className={`grow flex items-center gap-2 h-fit w-full max-w-[calc(100%-76px)] !no-underline
                        xl:!max-w-[240px] group-hover:xl:!max-w-[160px] `}
                        key={chatIdentifier}
                        onClick={() => {
                            if (!chatlistOpen) {
                                dispatch(setChatlistOpenHover(false));
                            }
                            setCanEdit('');
                            dispatch(setNavigationTitle(chatTitle));
                            dispatch(setNavigationSubTitle(assistantTitle));
                            dispatch(setNavigationImage(assistantImage));
                            dispatch(setMobileMenuOpen(false));
                            navigate(`/chats/${chatIdentifier}`);
                        }}
                    >
                        <Avatar
                            position={'realative'}
                            role={ChatMessageRole.assistant}
                            avatarImage={assistantImage}
                            title={assistantTitle}
                            size={32}
                        />
                        <p className={`text-chatlist-textcolor m-0 p-0 truncate`}>{initialTitle}</p>
                    </button>
                )}
                <div className={`w-fit flex gap-1 ${editItem !== chatIdentifier && 'group-hover:flex xl:hidden'}`}>
                    <span
                        className={`border-none text-chatlist-inlineButton-text bg-chatlist-inlineButton-background hover:bg-chatlist-inlineButton-background-hover rounded-full p-2 cursor-pointer hover:text-chatlist-inlineButton-text-hover md:group-hover:block `}
                        onClick={() => {
                            if (editItem === chatIdentifier) {
                                updateTitle();
                                setCanEdit('');
                            } else {
                                setCanEdit(chatIdentifier);
                            }
                        }}
                    >
                        {editItem === chatIdentifier ? <Check size={16} /> : <PencilSimple size={16} />}
                    </span>

                    <button
                        className={`border-none text-chatlist-inlineButton-text bg-chatlist-inlineButton-background hover:bg-chatlist-inlineButton-background-hover rounded-full p-2 cursor-pointer hover:text-chatlist-inlineButton-text-hover md:group-hover:block `}
                        onClick={() => {
                            if (editItem === chatIdentifier) {
                                setChatTitleInput(initialTitle);
                                setCanEdit('');
                            } else {
                                deleteChat(chatIdentifier);
                            }
                        }}
                    >
                        {editItem === chatIdentifier ? <X size={16} /> : <Trash size={16} />}
                    </button>
                </div>
            </li>
        </>
    );
}
